import {useRef, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {useTranslation} from '../../../shared/language';

export const View = ({display, setDisplay, html}) => {

  const { t } = useTranslation();

  const preview = useRef(null);

  const [iframeHeight, setIframeHeight] = useState(100);

  const onShow = () => {
    if (html) {
      preview.current.contentWindow.document.open();
      preview.current.contentWindow.document.write(`${html.trim()}`);
      preview.current.contentWindow.document.close();
      const hoadonmau = preview.current.contentWindow.document.getElementsByClassName('hoadonmau');
      setIframeHeight(hoadonmau[0].offsetHeight);
    }
  }

  const print = () => {
    const myWindow = window.open();
    myWindow.document.open('text/plain');
    myWindow.document.write(html.trim());
    myWindow.document.close();
    myWindow.onafterprint = myWindow.close;
    myWindow.print();
  }
  const printSwitch = () => {
    const _html = html.trim().replace('(Bản thể hiện của hóa đơn điện tử)', '(Hóa đơn chuyển đổi từ hóa đơn điện tử)');
    const myWindow = window.open();
    myWindow.document.open('text/plain');
    myWindow.document.write(_html);
    myWindow.document.close();
    myWindow.onafterprint = myWindow.close;
    myWindow.print();
  }

  const myIcon = (
    <div className="mr-2 grid">
      <div className="col-fixed p-0 pt-3 text-right" style={{width: '470px'}}>
        <Button label={t('common.printConvertedInvoice')} icon="pi pi-print" onClick={printSwitch} className="p-button-outlined p-button-sm mr-2"/>
        <Button label={t('common.printInvoice')} icon="pi pi-print" onClick={print} className="p-button-outlined p-button-sm mr-2"/>
      </div>
    </div>
  );
  return (
    <Dialog icons={myIcon} visible={display} style={{width: '890px'}} draggable={false} resizable={true} position="top"
            onHide={() => setDisplay(false)} onShow={onShow} className="view-invoice">
      <iframe className="template-preview" ref={preview} title="template-preview" style={{height: iframeHeight}}/>
    </Dialog>
  );
}
